import { Component } from '@angular/core';
import { LayoutContainerComponent } from '../../components/layout-container/layout-container.component';
import { SectionHeadingComponent } from '../../components/section-heading/section-heading.component';
import { CtaBannerComponent } from '../../components/cta-banner/cta-banner.component';
import { OnboardingBookingSectionComponent } from '../../features/onboarding/components/onboarding-booking-section/onboarding-booking-section.component';
import { MessageUsSectionComponent } from '../../features/messageus/components/message-us-section/message-us-section.component';

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [
    LayoutContainerComponent,
    SectionHeadingComponent,
    CtaBannerComponent,
    OnboardingBookingSectionComponent,
    MessageUsSectionComponent
  ],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.css'
})
export class ContactUsComponent {}
